import { Card } from "react-bootstrap";
import { MdDateRange } from "react-icons/md";
import Link from "next/link";
import { FaUserAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import RichTextDisplay from "../richtext/display";
export default function WriteUpCard({
  post,
  isFromHomePage = false,
  source = "",
  user = { has_paid: false },
  showAll = false,
}) {
  // useEffect(() => {
  //   setShowActivateMembership(!user?.has_paid && post.fields?.paid === true);
  // }, [post.fields?.paid, user?.has_paid]);

  const blogLink = `/blog/${post.fields.title}${source ? "?s=" + source : ""}`;

  return (
    <Card className="blog-card" style={{ height: showAll ? "auto" : "100%", width: "auto" }}>
      <Link
        className={`d-flex justify-content-center border-bottom bg-dark px-4 ${showAll ? "gap-4" : null}`}
        href={blogLink}
      >
        <Card.Img
          variant="top"
          src={`/static/media/logos/${post.home_team}.png`}
          style={{ maxWidth: "50%", maxHeight: "10rem", width: "auto", margin: "0px" }}
        />
        <Card.Img
          variant="top"
          src={`/static/media/logos/${post.away_team}.png`}
          style={{ maxWidth: "50", maxHeight: "10rem", width: "auto", margin: "0px" }}
        />
      </Link>

      <Card.Body className="pt-0 mt-3">
        <Link
          className="text-black is-link"
          href={`/${post?.tag.split("-")[1]}/matchup-output/${post.home_team}/${post.away_team}/${post.date}`}
        >
          <Card.Title style={{ fontSize: "1.4rem" }}>
            {post.home_team} vs {post.away_team}
          </Card.Title>
        </Link>
        <div
          className="d-flex"
          style={{
            fontSize: "12px",
            color: "#6B6C72",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <span>
            <MdDateRange /> {post?.date}{" "}
          </span>
          <span>
            {/* <Link href={`/author/${post.fields.blogAuthor.fields.name}`}>
              <FaUserAlt /> {post.fields.blogAuthor.fields.name}
            </Link> */}
          </span>
        </div>
        <div className="card-text text-black" style={{ fontSize: showAll ? "1.02rem" : ".9rem" }}>
          {showAll ? (
            <RichTextDisplay content={post.preview} />
          ) : (
            <RichTextDisplay content={post.preview.split(" ").slice(0, 100).join(" ") + "..."} />
          )}
        </div>
        {!showAll ? (
          <Link className="btn btn-orange mt-2" href={blogLink}>
            Read More
          </Link>
        ) : (
          <div className="text-center">
            <Link
              className="btn btn-orange mt-4 px-5"
              href={`/nba/matchup-output/${post.home_team}/${post.away_team}/${post.date}`}
            >
              Game Page
            </Link>
          </div>
        )}
      </Card.Body>
    </Card>
  );
}
